export const slotGameDesignProcessTextContent = {
  headingText: (
    <>
      <span>Slot Game Design</span>{" "} <span>Process</span>
    </>
  ),
  content: [
    {
      titleText: "Preparations Of Game Document",
      paraText:
        "We start by crafting a perfect blueprint, outlining every minor detail, every feature, theme, and game mechanics. This blueprint acts as the cornerstone that keeps the project focused, consistent and on track.",
      imageSrc: "/assets/stock-img/game_document_img.webp",
    },
    {
      titleText: "Maths Model & RTP Simulation",
      paraText:
        "Our approach prioritizes fairness through mathematical models that shape volatility rates, game mechanics, fair payout structures and more while RTP simulations ensure a well-balanced reward system and foster player loyalty.",
      imageSrc: "/assets/stock-img/maths_model_img.webp",
    },
  ],
};
